import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{staticClass:"ml-3 mr-4",attrs:{"elevation":"1","fab":"","small":""},on:{"click":function($event){_vm.mini = !_vm.mini}}},[_c(VIcon,[_vm._v(" "+_vm._s(_vm.mini ? 'mdi-format-list-bulleted' : 'mdi-dots-vertical')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }